/** Core contract (`cookie-consent-fab.tsx`): the consent client opens its settings on this event. */
export const OPEN_COOKIE_PREFERENCES_EVENT = 'eliadmin:open-cookie-preferences';
/** `?occ=true` opens the settings – the link of the footer menu item „Cookies“ (also without JS). */
export const OPEN_COOKIE_PREFERENCES_PARAM = 'occ';

/** A menu link meant to open the cookie settings (`/?occ=true` from the administration). */
export function isCookieSettingsHref(href: string) {
  return (
    new URLSearchParams(href.split('?')[1]?.split('#')[0]).get(OPEN_COOKIE_PREFERENCES_PARAM) ===
    'true'
  );
}

/** Asks the consent client to open the settings on the current page; false when none handled it. */
export function requestCookieSettings() {
  const detail = { handled: false };
  window.dispatchEvent(new CustomEvent(OPEN_COOKIE_PREFERENCES_EVENT, { detail }));
  return detail.handled;
}
